import { render } from "./RoadWarrant.vue?vue&type=template&id=c3cd7152"
import script from "./RoadWarrant.vue?vue&type=script&lang=js"
export * from "./RoadWarrant.vue?vue&type=script&lang=js"
script.render = render

export default script